import { useContext, useEffect, useRef } from "react";
import globalStates from "../../utils/global";
import "./ShopScreen2.css"

const openInNewTab = (url: string) => {
  if (!url.startsWith("http")) {
    url = "https://" + url;
  }
  window.open(url, "_blank", "noopener,noreferrer");
};

const ShopScreen2 = () =>{

    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    
    // const businessDetailImagesImg = businessDetailImages && businessDetailImages.screenBannerImg;

    const screenWebsiteRef = useRef(null) as any;
    // console.log({})

    const handleButtonOrderHere=()=>{
        const url='https://kunocultures.myshopify.com'
        openInNewTab(url)
    }
    useEffect(()=>{
        const handleScroll =()=>{
            const setScreensOffset = globalContext && globalContext.setScreensOffset;
            const screenWebsite = screenWebsiteRef.current.getBoundingClientRect();
            const top = screenWebsite.top;
            const bottom = screenWebsite.bottom;
            const offset = globalContext && globalContext.windowHeight;
            setScreensOffset((prev:any)=>{return {...prev, 
                isOffsetscreenWebsite: false, bottom, offset, top
            }});
            if(top < (-1*0.005*offset) ){
                setScreensOffset((prev:any)=>{return {...prev, bottom, offset, top,
                    isOffsetscreenWebsite: true,
                }});
            };
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [globalContext])

    const componentData = {
        background: {
            image: {
                src: "",
                alt: ""
            }
        },
        shield: {

        },
        content: {

        }
    }
    
    return(
        <>
            <div 
            ref={screenWebsiteRef} 
            className={`${windowWidthClass}-shop-screen-2 wrapper`}>

                <div className="background">
                    <div className="frame">
                        <img
                            alt = {componentData.background.image.alt}
                            src = {componentData.background.image.src}
                        />
                    </div>
                </div>
                <div className="shield">

                </div>
                <div className="content display">
                    <p className="button-order" onClick={handleButtonOrderHere}>ORDER HERE</p>
                </div>

            </div>
        </>
        
    )
};

export default ShopScreen2;